import { Drill } from 'config/commonTypes';
import React, { useCallback, useEffect, useState } from 'react';

import { useInterval } from '../../../helpers/customHooks';
import { msToTime } from '../../../helpers/helpers';

export default ({ drill }: {drill:Drill}) => {
  const getDifference = useCallback(() => {
    return drill.startTs ? new Date().getTime() - drill.startTs : 0;
  }, [drill.startTs]);
  const [differenceInMilliseconds, setDifferenceInMilliseconds] = useState(getDifference());

  const [live, setLive] = useState<number|null>(null);
  const delayTime = 1000;
  useInterval(() => setDifferenceInMilliseconds(getDifference()), live);
  useEffect(() => {
    setTimeout(() => {
      setLive(delayTime);
    }, delayTime - differenceInMilliseconds % delayTime);
  }, [drill]);

  return (<p style={{ color: '#007CB0', fontWeight: 'bold', marginBottom: '0px' }}>
    <i className="mdi mdi-timer-outline" />{'  '}{differenceInMilliseconds >= 0 ? msToTime(differenceInMilliseconds)
    : '— : — : —'}
  </p>);
};
